// extracted by mini-css-extract-plugin
module.exports =  {"link":"LinkComponent_link__12np7","icon":"LinkComponent_icon__cHMNp"};